import { Grid, Typography } from "@mui/material";

export const PageHeading = (props) => <Grid item xs={12} sx={{ mb: -1, width: '100%',flexBasis: '100%' }}>
    <Typography style={props.style} variant={props.variant} textAlign={props.textAlign}>{props.name}</Typography>
</Grid>